"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleLoyaltyObject = exports.GooglePass = exports.VerifyResult = exports.RefreshWithoutProfileResult = exports.RefreshResult = exports.LoginResult = exports.Subscription = exports.Brand = exports.LinkedAccounts = exports.TenantJson = exports.TenantAssociation = exports.BusinessUnitCode = exports.OptionString = exports.OptionNone = exports.VerifyQuery = exports.JwtLoginPayload = exports.RefreshPayload = exports.LoginPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const User = __importStar(require("../../../../user"));
const Field = __importStar(require("../../../openapi/field"));
const Account = __importStar(require("../account/schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Auth.Schema';
const appIdField = Field.nonEmpty('Client application id. It must be a registered, enabled application (looked up in the database, so the schema can only require a non-empty string).');
const profileTypeField = (description) => effect_1.Schema.optionalWith(effect_1.Schema.Literal('basic', 'full'), { exact: true }).annotations({ description });
exports.LoginPayload = effect_1.Schema.Struct({
    email: effect_1.Schema.propertySignature(effect_1.Schema.String.annotations({ jsonSchema: { type: 'string', format: 'email' } })).annotations({ description: 'Email address. The server lower-cases it before use.' }),
    password: Field.nonEmpty('Password'),
    profile: profileTypeField('Adds profile fields to the answer: basic adds email and names, full also adds the dashboard. Nothing is added when omitted.'),
    skipLinkedAccounts: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.Boolean, effect_1.Schema.Literal('true', 'false', '1', '0')), {
        exact: true,
    }).annotations({
        description: 'Skips the sign-in of linked accounts (defaults to false). Any string form, "false" included, counts as true. There are no linked account providers today, so linkedAccounts is always empty.',
    }),
    appId: appIdField,
}).annotations({
    identifier: `${exports.NAMESPACE}.LoginPayload`,
    description: 'Request body to sign in with email and password',
});
exports.RefreshPayload = effect_1.Schema.Struct({
    refreshToken: Field.nonEmpty('Refresh token returned by a previous login'),
    appId: appIdField,
}).annotations({
    identifier: `${exports.NAMESPACE}.RefreshPayload`,
    description: 'Request body to exchange a refresh token for a new access token',
});
exports.JwtLoginPayload = effect_1.Schema.Struct({
    idToken: Field.nonEmpty('JWT issued by Apple (https://appleid.apple.com) or Google (https://accounts.google.com) for one of the Culligan applications'),
    firstName: Field.optionalString('First name for a new account. Defaults to the given_name claim, then to the first word of the name claim, then to "anonymous".'),
    lastName: Field.optionalString('Last name for a new account. Defaults to the family_name claim, then to the second word of the name claim, then to "user".'),
    timezone: Field.optionalString('IANA time zone name for a new account, such as Europe/Madrid. An unknown name is rejected with INVALID_TIMEZONE.'),
    profile: profileTypeField('Adds profile fields to the answer: basic adds email and names, full also adds the dashboard. Nothing is added when omitted.'),
    appId: appIdField,
}).annotations({
    identifier: `${exports.NAMESPACE}.JwtLoginPayload`,
    description: 'Request body to sign in with a JWT issued by a supported third party',
});
exports.VerifyQuery = effect_1.Schema.Struct({
    fastTokenVerification: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false', '1', '0'), {
        exact: true,
    }).annotations({
        description: 'Any accepted value, "false" and "0" included, makes the check fast: the handler only tests that the parameter is present, so the user id is not returned.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.VerifyQuery`,
    description: 'Query string of the token verification',
});
/*
 * The tenant is the decoded domain value: the controller does not encode it, so Effect `Option`
 * values reach the client in their JSON form.
 */
exports.OptionNone = effect_1.Schema.Struct({
    _id: effect_1.Schema.Literal('Option'),
    _tag: effect_1.Schema.Literal('None'),
}).annotations({
    identifier: `${exports.NAMESPACE}.OptionNone`,
    description: 'An empty Effect Option, serialized as an object',
});
const optionSome = (identifier, value) => effect_1.Schema.Struct({
    _id: effect_1.Schema.Literal('Option'),
    _tag: effect_1.Schema.Literal('Some'),
    value,
}).annotations({
    identifier,
    description: 'A present Effect Option, serialized as an object',
});
exports.OptionString = effect_1.Schema.Union(exports.OptionNone, optionSome(`${exports.NAMESPACE}.OptionStringSome`, effect_1.Schema.String)).annotations({
    identifier: `${exports.NAMESPACE}.OptionString`,
    description: 'An optional string serialized as an Effect Option object',
});
/** Codes of `Culligan.BusinessUnit.Base`; a test keeps this list in step with the domain. */
exports.BusinessUnitCode = effect_1.Schema.Literal('ESP', 'PRT', 'DEU', 'AUT', 'ITA', 'CHE', 'HUN', 'BEL', 'GBR', 'POL', 'LVA', 'EST', 'LTU', 'NLD', 'DNK', 'SWE', 'NOR', 'FIN', 'BGR', 'CZE', 'IRL', 'FRA', 'QNC').annotations({ identifier: `${exports.NAMESPACE}.BusinessUnitCode` });
const OptionBusinessUnit = effect_1.Schema.Union(exports.OptionNone, optionSome(`${exports.NAMESPACE}.OptionBusinessUnitSome`, effect_1.Schema.Struct({ _tag: exports.BusinessUnitCode }).annotations({
    identifier: `${exports.NAMESPACE}.BusinessUnit`,
    description: 'Business unit; _tag is its country code',
}))).annotations({
    identifier: `${exports.NAMESPACE}.OptionBusinessUnit`,
    description: 'An optional business unit serialized as an Effect Option object',
});
exports.TenantAssociation = effect_1.Schema.Struct({
    countryCode: effect_1.Schema.propertySignature(exports.OptionString).annotations({
        description: 'ISO 3166-1 alpha-2 country code the association matches',
    }),
    modelCode: effect_1.Schema.propertySignature(exports.OptionString).annotations({
        description: 'Device model code the association matches',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.TenantAssociation`,
    description: 'Rule that makes a tenant adopt the entities matching a country or a model',
});
const tenantFields = {
    id: Field.nonEmpty('Tenant id'),
    name: Field.nonEmpty('Tenant name'),
    createdAt: effect_1.Schema.propertySignature(Field.dateTime('ISO-8601 creation time')).annotations({
        description: 'ISO-8601 creation time',
    }),
    updatedAt: effect_1.Schema.propertySignature(Field.dateTime('ISO-8601 last update time')).annotations({
        description: 'ISO-8601 last update time',
    }),
    associations: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.TenantAssociation)).annotations({
        description: 'Associations of the tenant; an empty array when there are none',
    }),
    businessUnit: effect_1.Schema.propertySignature(OptionBusinessUnit).annotations({
        description: 'Business unit of the tenant',
    }),
    homeUrl: effect_1.Schema.propertySignature(exports.OptionString).annotations({ description: 'Home page URL' }),
    emailFromAddress: effect_1.Schema.propertySignature(exports.OptionString).annotations({
        description: 'Sender address of the emails the tenant sends',
    }),
    customDomainFrontend: effect_1.Schema.propertySignature(exports.OptionString).annotations({
        description: 'Custom host name of the tenant frontend',
    }),
};
exports.TenantJson = effect_1.Schema.suspend(() => effect_1.Schema.Struct({
    ...tenantFields,
    subTenants: effect_1.Schema.Array(exports.TenantJson),
})).annotations({
    identifier: `${exports.NAMESPACE}.TenantJson`,
    description: 'Tenant with its sub-tenants, as the server serializes it. Every optional value is an Effect Option object ({ _id: "Option", _tag: "Some", value } or { _id: "Option", _tag: "None" }), not a plain string or an absent field.',
});
exports.LinkedAccounts = effect_1.Schema.Struct({}).annotations({
    identifier: `${exports.NAMESPACE}.LinkedAccounts`,
    description: 'Sessions of linked accounts by provider. Always empty: no provider is configured.',
    jsonSchema: { type: 'object', additionalProperties: false, properties: {} },
});
exports.Brand = effect_1.Schema.Struct({
    color: Field.optionalString('Primary color of the brand; absent when the brand has none'),
    logo: Field.optionalString('Logo of the brand; absent when the brand has none'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Brand`,
    description: 'Branding of the user',
});
exports.Subscription = effect_1.Schema.Union(effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Subscription id' }),
    expiresAt: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({
        description: 'Expiry in milliseconds since the epoch',
    }),
}).annotations({ identifier: `${exports.NAMESPACE}.ActiveSubscription` }), effect_1.Schema.Struct({
    message: effect_1.Schema.Literal('No current subscription'),
}).annotations({ identifier: `${exports.NAMESPACE}.NoSubscription` })).annotations({
    identifier: `${exports.NAMESPACE}.Subscription`,
    description: 'Active Pelican subscription, or a message when there is none',
});
const tenantField = effect_1.Schema.optionalWith(exports.TenantJson, { exact: true }).annotations({
    description: 'Tenant of the user. Absent when the user has no tenant or it cannot be loaded; the failure is logged and does not fail the request.',
});
const sessionFields = {
    userId: Field.nonEmpty('Culligan user id (not the identity provider id)'),
    accessToken: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Access token to send as a Bearer token',
    }),
    refreshToken: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Refresh token; see the refresh operation',
    }),
    expiresIn: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({
        description: 'Lifetime of the access token in seconds',
    }),
    linkedAccounts: effect_1.Schema.propertySignature(exports.LinkedAccounts),
    roles: effect_1.Schema.propertySignature(effect_1.Schema.Array(User.GlobalUserRole)).annotations({
        description: 'Global roles of the user',
    }),
    tenantId: Field.nullableString('Tenant id, or null when the user has none'),
    tenant: tenantField,
};
const profileNote = 'Present when the request asks for a basic or full profile.';
const dashboardNote = 'Present when the request asks for the full profile.';
const storedName = 'With the basic profile it is the stored value, null when an account update sent an empty string; with the full profile it is an empty string instead of null.';
exports.LoginResult = effect_1.Schema.Struct({
    ...sessionFields,
    brand: effect_1.Schema.optionalWith(exports.Brand, { exact: true }).annotations({
        description: 'Branding of the user brand; absent when the user has no brand or it is not found',
    }),
    email: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }).annotations({
        description: `Email address. ${profileNote} It is null when the stored profile has none: a full update of the account without an email stores null, and the sign-in still works.`,
    }),
    firstName: Field.optionalNullableString(`First name. ${profileNote} ${storedName}`),
    lastName: Field.optionalNullableString(`Last name. ${profileNote} ${storedName}`),
    hydrationGoals: effect_1.Schema.optionalWith(Account.HydrationGoals, { exact: true }).annotations({
        description: `Hydration goals; an empty object when none are set. ${dashboardNote}`,
    }),
    hydrationStatus: effect_1.Schema.optionalWith(Account.HydrationStatus, { exact: true }).annotations({
        description: `Hydration progress today. ${dashboardNote}`,
    }),
    hydrationHistory: effect_1.Schema.optionalWith(Account.HydrationHistory, { exact: true }).annotations({
        description: `Hydration history. ${dashboardNote}`,
    }),
    goalsSummary: effect_1.Schema.optionalWith(Account.GoalsSummary, { exact: true }).annotations({
        description: `Summary of the hydration goals. ${dashboardNote}`,
    }),
    containers: effect_1.Schema.optionalWith(effect_1.Schema.Array(Account.Container), { exact: true }).annotations({
        description: `Containers of the user. ${dashboardNote}`,
    }),
    subscription: effect_1.Schema.optionalWith(exports.Subscription, { exact: true }).annotations({
        description: `Pelican subscription. ${dashboardNote}`,
    }),
    avatar: effect_1.Schema.optionalWith(Account.Avatar, { exact: true }).annotations({
        description: `Avatar of the user. ${dashboardNote}`,
    }),
    accentColor: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }).annotations({
        description: `Accent color, null when none is set. ${dashboardNote}`,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.LoginResult`,
    description: 'Session of the signed-in user, with optional profile fields',
});
exports.RefreshResult = effect_1.Schema.Struct(sessionFields).annotations({
    identifier: `${exports.NAMESPACE}.RefreshResult`,
    description: 'Session of the user with a new access token',
});
exports.RefreshWithoutProfileResult = effect_1.Schema.Struct({
    accessToken: sessionFields.accessToken,
    refreshToken: sessionFields.refreshToken,
    expiresIn: sessionFields.expiresIn,
    linkedAccounts: sessionFields.linkedAccounts,
    tenantId: effect_1.Schema.propertySignature(effect_1.Schema.Null).annotations({
        description: 'Always null: the user has no profile',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RefreshWithoutProfileResult`,
    description: 'Session with a new access token for a user that has no profile in the database, without userId and roles',
});
exports.VerifyResult = effect_1.Schema.Struct({
    userId: Field.nonEmpty('Culligan user id of the token owner'),
}).annotations({
    identifier: `${exports.NAMESPACE}.VerifyResult`,
    description: 'Owner of the verified token',
});
exports.GooglePass = effect_1.Schema.Struct({
    url: effect_1.Schema.propertySignature(effect_1.Schema.String.annotations({ jsonSchema: { type: 'string', format: 'uri' } })).annotations({
        description: 'Save-to-Google-Wallet link, https://pay.google.com/gp/v/save/ followed by a signed JWT',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.GooglePass`,
    description: 'Link that adds the loyalty pass of the user to Google Wallet',
});
const optionalField = (schema, description) => effect_1.Schema.optionalWith(schema, { exact: true }).annotations({ description });
const GoogleLoyaltyPoints = effect_1.Schema.Struct({
    label: optionalField(effect_1.Schema.String, 'Label of the counter'),
    balance: optionalField(effect_1.Schema.Struct({ string: optionalField(effect_1.Schema.String, 'Text shown as the balance') }), 'Balance of the counter'),
}).annotations({
    identifier: `${exports.NAMESPACE}.GoogleLoyaltyPoints`,
    description: 'Loyalty counter of the pass',
});
const googleKind = optionalField(effect_1.Schema.String, 'Resource type Google adds, such as walletobjects#uri');
const googleTranslatedString = effect_1.Schema.Struct({
    kind: googleKind,
    language: optionalField(effect_1.Schema.String, 'Language tag'),
    value: optionalField(effect_1.Schema.String, 'Text'),
});
const googleLocalizedString = effect_1.Schema.Struct({
    kind: googleKind,
    defaultValue: optionalField(googleTranslatedString, 'Text in the default language'),
    translatedValues: optionalField(effect_1.Schema.Array(googleTranslatedString), 'Translations of the text'),
});
const GoogleAppLinkData = effect_1.Schema.Struct({
    androidAppLinkInfo: optionalField(effect_1.Schema.Struct({
        appLogoImage: optionalField(effect_1.Schema.Struct({
            kind: googleKind,
            sourceUri: optionalField(effect_1.Schema.Struct({ uri: optionalField(effect_1.Schema.String, 'Image URL') }), 'Image source'),
        }), 'Logo of the app'),
        title: optionalField(googleLocalizedString, 'Title of the app link'),
        description: optionalField(googleLocalizedString, 'Description of the app link'),
        appTarget: optionalField(effect_1.Schema.Struct({
            targetUri: optionalField(effect_1.Schema.Struct({
                kind: googleKind,
                id: optionalField(effect_1.Schema.String, 'Identifier of the link'),
                uri: optionalField(effect_1.Schema.String, 'Install page of the app'),
                description: optionalField(effect_1.Schema.String, 'Text of the link'),
            }), 'Target of the link'),
        }), 'Where the link leads'),
    }), 'Android app link'),
}).annotations({
    identifier: `${exports.NAMESPACE}.GoogleAppLinkData`,
    description: 'Link to the Culligan app shown on the pass',
});
/** The class is set up at Google, not by this API, so its fields are not listed and the object stays open. */
const GoogleLoyaltyClass = effect_1.Schema.Struct({
    id: optionalField(effect_1.Schema.String, 'Id of the loyalty class'),
}).annotations({
    identifier: `${exports.NAMESPACE}.GoogleLoyaltyClass`,
    jsonSchema: {
        type: 'object',
        description: 'The loyalty class of the pass as Google stores it; only the id is listed',
        properties: { id: { type: 'string', description: 'Id of the loyalty class' } },
        additionalProperties: true,
    },
});
exports.GoogleLoyaltyObject = effect_1.Schema.Struct({
    kind: optionalField(effect_1.Schema.String, 'Resource type, walletobjects#loyaltyObject'),
    id: Field.nonEmpty('Google Wallet object id, the issuer id and a hash of the user email'),
    classId: optionalField(effect_1.Schema.String, 'Id of the loyalty class the pass belongs to'),
    classReference: optionalField(GoogleLoyaltyClass, 'Copy of the loyalty class'),
    version: optionalField(effect_1.Schema.String, 'Version of the object, an integer sent as a string'),
    state: optionalField(effect_1.Schema.String, 'State of the pass, ACTIVE when the API created it'),
    hasUsers: optionalField(effect_1.Schema.Boolean, 'Whether a user has saved the pass'),
    smartTapRedemptionValue: optionalField(effect_1.Schema.String, 'The pass record id, a SHA-1 of "google." and the user email'),
    loyaltyPoints: optionalField(GoogleLoyaltyPoints, 'PLASTIC ELIMINATED counter'),
    secondaryLoyaltyPoints: optionalField(GoogleLoyaltyPoints, 'NEXT LEVEL AT counter'),
    appLinkData: optionalField(GoogleAppLinkData, 'Link to the Culligan app'),
}).annotations({
    identifier: `${exports.NAMESPACE}.GoogleLoyaltyObject`,
    description: 'The Google Wallet loyalty object as Google answers the update: the fields this API writes and the ones Google adds to them.',
});
//# sourceMappingURL=schema.js.map